import useTranslation from 'next-translate/useTranslation'

import { DescriptionItem } from './DescriptionItem/DescriptionItem'

export const Description: React.FC = () => {
  const { t } = useTranslation('faucet')
  return (
    <div className="max-w-lg px-4" data-testid="faucet-description">
      <div className="type-header-2xl mb-8 text-center sm:text-left">{t`description.headline`}</div>
      <div className="flex flex-col space-y-6">
        <DescriptionItem
          description={t`description.items.0.description`}
          icon="CodeOutline"
          title={t`description.items.0.title`}
        />
        <DescriptionItem
          description={t`description.items.1.description`}
          icon="SparklesOutline"
          title={t`description.items.1.title`}
        />
        <DescriptionItem
          description={t`description.items.2.description`}
          icon="CubeTransparentOutline"
          title={t`description.items.2.title`}
        />
      </div>
    </div>
  )
}
